module.exports = __webpack_public_path__ + "static/buttbot-icon-8c2e1200c991244b7e9bd8c71ef1f9db.png";